import {
  addQueryParams,
  FlexColumnCenterVertical,
  useRouter,
} from '@main/core-ui';
import { SanitizeHtml } from '@main/pc-core-components';
import { usePartition } from '@main/privacy-center/src/hooks/usePartition';
import React from 'react';
import { useIntl } from 'react-intl';

import { selectPartitionMessages } from './messages';
import { StyledReactSelect } from './wrappers';

/**
 * Component to select the Preference Store partitions
 */
export const SelectPartition: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { formatMessage } = useIntl();
  const { redirect, location } = useRouter();
  const [
    {
      allowPartitionChange,
      showPartition,
      partitionOptions,
      selectedPartitionOption,
    },
    setPartition,
  ] = usePartition();

  return (
    <>
      {partitionOptions.length > 1 && showPartition && (
        <FlexColumnCenterVertical style={{ flex: '1' }}>
          <p>
            <SanitizeHtml
              html={formatMessage(
                allowPartitionChange
                  ? selectPartitionMessages.selectPartition
                  : selectPartitionMessages.selectedPartition,
              )}
            />
          </p>

          {allowPartitionChange ? (
            <StyledReactSelect
              isMulti={false}
              id="select-consent-partition"
              variant="light"
              options={partitionOptions}
              value={selectedPartitionOption}
              isClearable={false}
              getOptionLabel={(option) => option.label}
              onChange={(option) => {
                if (option) {
                  setPartition(option.partition);
                  redirect(
                    addQueryParams(location, {
                      partition: option.value,
                    }),
                  );
                  window.location.reload();
                }
              }}
            />
          ) : (
            <i>{selectedPartitionOption?.label}</i>
          )}
        </FlexColumnCenterVertical>
      )}
    </>
  );
};
